import { render, staticRenderFns } from "./detailPure_p.vue?vue&type=template&id=fbf5052e&scoped=true"
import script from "./detailPure_p.vue?vue&type=script&lang=js"
export * from "./detailPure_p.vue?vue&type=script&lang=js"
import style0 from "./detailPure_p.vue?vue&type=style&index=0&id=fbf5052e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5052e",
  null
  
)

export default component.exports